import { filter } from "../filter.js";
import { castArray } from "./castArray.js";
const everyTagFilter = tags => {
  return filter.at("document.tags", castArray(tags));
};
export { everyTagFilter };
